import * as React from 'react';
import './style.less';
import TouchFeedback from '../feed-back';
import { createElement } from 'react';
import CB_ENABLED_IMAGE_LEFT from './images/checkBox_enabled_left.png';
import CB_DISABLED_IMAGE_LEFT from './images/checkBox_disabled_left.png';
import CB_ENABLED_IMAGE_LEFT_GRAY from './images/checkBox_enabled_left_gray.png';
import CB_DISABLED_IMAGE_LEFT_GRAY from './images/checkBox_disabled_left_gray.png';
import CB_ENABLED_IMAGE_RIGHT from './images/checkBox_enabled_right.png';
import CB_DISABLED_IMAGE_RIGHT from './images/checkBox_disabled_right.png';
import CB_ENABLED_IMAGE_RIGHT_GRAY from './images/checkBox_enabled_right_gray.png';
import CB_DISABLED_IMAGE_RIGHT_GRAY from './images/checkBox_disabled_right_gray.png';
import CB_ENABLED_IMAGE_AGREEMENT from './images/checkBox_enabled_agreement.png';
import CB_DISABLED_IMAGE_AGREEMENT from './images/checkBox_disabled_agreement.png';
CheckBox.defaultProps = {
    checkedImageLeft: CB_ENABLED_IMAGE_LEFT,
    uncheckedImageLeft: CB_DISABLED_IMAGE_LEFT,
    disabledCheckedImageLeft: CB_ENABLED_IMAGE_LEFT_GRAY,
    disabledUncheckedImageLeft: CB_DISABLED_IMAGE_LEFT_GRAY,
    checkedImageRight: CB_ENABLED_IMAGE_RIGHT,
    uncheckedImageRight: CB_DISABLED_IMAGE_RIGHT,
    disabledCheckedImageRight: CB_ENABLED_IMAGE_RIGHT_GRAY,
    disabledUncheckedImageRight: CB_DISABLED_IMAGE_RIGHT_GRAY,
    checkedImageAgreement: CB_ENABLED_IMAGE_AGREEMENT,
    uncheckedImageAgreement: CB_DISABLED_IMAGE_AGREEMENT,
    label: '复选框',
    isChecked: true,
    checked: null,
    labelBefore: false,
    disabled: false,
    hasIcon: false,
    color: '#333333',
    fontSize: 15,
    type: 'normal',
    isChange: false,
    widthFlag: '0',
};
function CheckBox(props) {
    const { value, checked, isChecked, label, desc, labelBefore, hasIcon, source, disabled, fontSize, color, type, children, checkedImageLeft, uncheckedImageLeft, checkedImageAgreement, uncheckedImageAgreement, disabledCheckedImageLeft, disabledUncheckedImageLeft, checkedImageRight, uncheckedImageRight, disabledCheckedImageRight, disabledUncheckedImageRight, } = props;
    console.log('1.checkedImageLeft: ', CB_ENABLED_IMAGE_LEFT);
    console.log('2.uncheckedImageLeft: ', CB_DISABLED_IMAGE_LEFT);
    console.log('3.disabledCheckedImageLeft: ', CB_ENABLED_IMAGE_LEFT_GRAY);
    console.log('4.disabledUncheckedImageLeft: ', CB_DISABLED_IMAGE_LEFT_GRAY);
    console.log('5.checkedImageRight: ', CB_ENABLED_IMAGE_RIGHT);
    console.log('6.uncheckedImageRight: ', CB_DISABLED_IMAGE_RIGHT);
    console.log('7.disabledCheckedImageRight: ', CB_ENABLED_IMAGE_RIGHT_GRAY);
    console.log('8.disabledUncheckedImageRight: ', CB_DISABLED_IMAGE_RIGHT_GRAY);
    console.log('9.checkedImageAgreement: ', CB_ENABLED_IMAGE_AGREEMENT);
    console.log('10.uncheckedImageAgreement: ', CB_DISABLED_IMAGE_AGREEMENT);
    const [prevPropsInternalChecked, setPrevPropsInternalChecked] = React.useState(isChecked);
    const [internalChecked, setInternalChecked] = React.useState(isChecked);
    React.useEffect(() => {
        if (isChecked !== prevPropsInternalChecked) {
            setPrevPropsInternalChecked(isChecked);
            setInternalChecked(isChecked);
        }
    }, [isChecked]);
    const onChange = () => {
        const newState = !internalChecked;
        if (props.onChange) {
            props.onChange(newState, value);
        }
        setInternalChecked(newState);
    };
    let container;
    let containerMinHeight = 44;
    let sourceLeft;
    let sourceLeftDisabled;
    let sourceRight;
    let sourceRightDisabled;
    let sourceAgreement;
    let checkboxLeftStyles = {};
    const iconStyles = 'icon';
    switch (type) {
        case 'normal':
            break;
        case 'agreement':
            checkboxLeftStyles = Object.assign(checkboxLeftStyles, {
                width: '15px',
                height: '15px',
            });
            break;
        default:
            break;
    }
    if (typeof checked === 'boolean') {
        sourceLeft = checked ? checkedImageLeft : uncheckedImageLeft;
        sourceAgreement = checked ? checkedImageAgreement : uncheckedImageAgreement;
    }
    else {
        sourceLeft = internalChecked ? checkedImageLeft : uncheckedImageLeft;
        sourceAgreement = internalChecked
            ? checkedImageAgreement
            : uncheckedImageAgreement;
    }
    if (typeof checked === 'boolean') {
        sourceLeftDisabled = checked
            ? disabledCheckedImageLeft
            : disabledUncheckedImageLeft;
    }
    else {
        sourceLeftDisabled = internalChecked
            ? disabledCheckedImageLeft
            : disabledUncheckedImageLeft;
    }
    if (typeof checked === 'boolean') {
        sourceRight = checked ? checkedImageRight : uncheckedImageRight;
    }
    else {
        sourceRight = internalChecked ? checkedImageRight : uncheckedImageRight;
    }
    if (typeof checked === 'boolean') {
        sourceRightDisabled = checked
            ? disabledCheckedImageRight
            : disabledUncheckedImageRight;
    }
    else {
        sourceRightDisabled = internalChecked
            ? disabledCheckedImageRight
            : disabledUncheckedImageRight;
    }
    if (labelBefore) {
        let icon;
        let rightDescClassName = 'rightDescContainer';
        if (hasIcon) {
            icon = createElement("img", { className: iconStyles, src: source });
            rightDescClassName = `${rightDescClassName} rightDescContainer-hasIcon`;
        }
        let descElement;
        if (desc) {
            descElement = createElement("span", { className: rightDescClassName }, desc);
            containerMinHeight = 67;
        }
        container = [
            createElement("div", { key: 1, className: "iftide-container", style: { justifyContent: 'space-between' } },
                createElement("div", { className: "containerRight" },
                    icon,
                    label ? (createElement("div", { className: 'labelContainerRight' },
                        createElement("span", { className: 'titleContainer', style: { fontSize: `${fontSize}px`, color } }, label))) : null,
                    children ? createElement("div", null, children) : null),
                createElement("img", { className: 'checkboxRight', src: disabled ? sourceRightDisabled : sourceRight })),
            descElement,
        ];
    }
    else if (type === 'normal') {
        let descElement;
        if (desc) {
            descElement = createElement("span", { className: 'leftDescContainer' }, desc);
            containerMinHeight = 67;
        }
        container = [
            createElement("div", { key: 2, className: 'iftide-container' },
                createElement("img", { className: 'checkboxLeft', style: checkboxLeftStyles, src: disabled ? sourceLeftDisabled : sourceLeft }),
                label ? (createElement("div", { className: 'labelContainerLeft' },
                    createElement("span", { className: 'titleContainer', style: { fontSize: `${fontSize}px`, color } }, label))) : (createElement("div", null))),
            descElement,
        ];
    }
    else if (type === 'agreement') {
        container = [
            createElement("div", { key: 3, className: 'container-agreement' },
                createElement("img", { className: 'container-agreement-img', src: sourceAgreement }),
                createElement("div", { className: 'container-agreement-children' }, children)),
        ];
    }
    return (createElement(TouchFeedback, { disabled: disabled, activeStyle: {
            opacity: 0.7,
        } },
        createElement("div", { className: "iftide-checkbox", style: { minHeight: `${containerMinHeight}px` }, onClick: !disabled ? onChange : undefined }, container)));
}
export default CheckBox;
